import React from "react";
import CelticOrnament from "@/components/CelticOrnament";

const IMG_STONES =
  "https://customer-assets.emergentagent.com/job_missing-deploy-3/artifacts/00sy7l58_Screenshot_20260515_175846_Gallery.jpg";
const IMG_CANDLE =
  "https://customer-assets.emergentagent.com/job_missing-deploy-3/artifacts/lpx7ngsm_Screenshot_20260515_175901_Gallery.jpg";
const IMG_HANDS =
  "https://customer-assets.emergentagent.com/job_missing-deploy-3/artifacts/t0wy9q4l_Screenshot_20260515_175941_Gallery.jpg";
const IMG_DOOR =
  "https://customer-assets.emergentagent.com/job_missing-deploy-3/artifacts/fimiqgkz_Screenshot_20260515_180006_Gallery.jpg";

const cards = [
  { src: IMG_DOOR, alt: "An old wooden door cracked open into golden light — 'The thing you keep avoiding is the thing that's keeping you small.'", label: "THE THRESHOLD" },
  { src: IMG_HANDS, alt: "Tattooed hands releasing a stone in candlelight — 'Not everyone who hurt you meant to. But you still get to put it down.'", label: "THE LETTING GO" },
  { src: IMG_CANDLE, alt: "A single candle and clear crystal on a stone sill at dusk — 'Something is working on your behalf even when you can't feel it.'", label: "THE QUIET" },
  { src: IMG_STONES, alt: "Standing stones beneath a starlit sunset sky — 'You belong to something ancient.'", label: "THE ANCIENT BELONGING" },
];

export default function WhispersGallery() {
  return (
    <section
      id="whispers"
      className="relative bg-charcoal-2 py-24 md:py-32 border-y border-[rgba(201,169,97,0.18)]"
      data-testid="whispers-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="eyebrow">A GLIMPSE OF THE DECKS</div>
          <h2 className="section-heading text-3xl md:text-5xl mt-5 leading-tight">
            Whispers from{" "}
            <span className="gold-gradient-text">Albetheine</span>
          </h2>
          <CelticOrnament size={70} className="mx-auto mt-5 opacity-70" />
          <p className="font-cormorant italic text-cream-soft text-lg md:text-xl max-w-2xl mx-auto mt-7 leading-relaxed">
            Four early whispers from Albetheine&apos;s Beacon &amp; Shadow Oracle
            decks &mdash; the hand-illustrated print-on-demand decks coming
            soon. Each card a moving image, a quiet truth, a doorway.
          </p>
        </div>

        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6"
          data-testid="whispers-grid"
        >
          {cards.map((c, i) => (
            <figure
              key={c.label}
              className="relative card-occult overflow-hidden group"
              data-testid={`whisper-card-${i}`}
            >
              <img
                src={c.src}
                alt={c.alt}
                loading="lazy"
                className="block w-full h-auto transition-transform duration-700 group-hover:scale-105"
              />
              <span className="corner-ornament corner-tl" />
              <span className="corner-ornament corner-tr" />
              <span className="corner-ornament corner-bl" />
              <span className="corner-ornament corner-br" />
              <figcaption className="absolute top-3 left-3 right-3 flex justify-center">
                <div className="font-cinzel text-gold-bright text-[0.6rem] tracking-[0.32em] bg-charcoal/70 backdrop-blur-sm px-3 py-1 border border-[rgba(201,169,97,0.4)]">
                  {c.label}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="text-center mt-14">
          <a
            href="#founders-circle"
            className="btn-gold"
            data-testid="whispers-cta-founders"
          >
            Join the Decks Waiting List
          </a>
        </div>
      </div>
    </section>
  );
}
